import { DialogContent, MenuItem, Stack } from "@mui/material";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import useLocales from "src/hooks/useLocales";

import FormFooter from "./FormFooter";
import useCreateUserForm from "./hooks/useCreateUserForm";

const ROLES = ["ROLE_ORG_ADMIN", "ROLE_ORG_EDITOR", "ROLE_ORG_VIEWER"];

const sxItem = {
	mx: 1,
	my: 0.5,
	borderRadius: 0.75,
	typography: "body2"
};

export default function CreateUserForm() {
	const { methods, onSubmit, isLoading } = useCreateUserForm();

	const { translate } = useLocales();

	return (
		<FormProvider autocomplete='off' methods={methods} onSubmit={onSubmit}>
			<DialogContent sx={{ mt: 0 }}>
				<Stack gap={3}>
					<RHFTextField
						name={"email"}
						label='Email'
						placeholder={translate("organization.add_email")}
					/>
					{/* <RHFTextField fullWidth select name={"role"}>
						{ROLES.map((option, index) => (
							<MenuItem key={index} value={option} sx={sxItem}>
								{option}
							</MenuItem>
						))}
					</RHFTextField> */}
				</Stack>
			</DialogContent>
			<FormFooter isLoading={isLoading} />
		</FormProvider>
	);
}
